<template>
  <div>
    <div class="forms-container">
      <el-form :model="searchForm" class="search-form" ref="searchFormRef">
        <el-form-item label="" prop="searchContent">
          <el-input
              style="width:300px"
              :maxlength="100"
              v-model="searchForm.searchContent"
              placeholder="券商品名称/ID"
          />
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableList.list" v-loading="loading" highlight-current-row border style="width: 100%">
      <el-table-column prop="name" label="券商品名称"/>
      <el-table-column prop="templateCode" label="券商品ID" />
      <el-table-column prop="darenNum" label="推广达人数" />
      <el-table-column prop="agentCommissionBd" label="我的服务费" />
    </el-table>
    <el-pagination
        v-if="tableList.total > 0"
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableList.currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="tableList.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableList.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import poi from "@/api/poi";
const PoiModel = new poi();
export default {
  data() {
    return {
      searchForm: {
        searchContent: '',
      },
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[],
      },
      visible: false
    }
  },
  created() {
    this.getList()
  },
  methods:{
    getParams(){
      return {
        ...this.searchForm,
      }
    },
    async getList() {
      this.loading = true
      const res = await PoiModel.getDistributeGoodsNum({
        ...this.getParams(),
        pageNo: this.params.pageNo,
        pageSize: this.params.pageSize,
      });
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.tableList.list = res.data.data.list || [];
      this.tableList.total = res.data.data.total || 0;
      this.loading = false;
      this.tableList.currentPage = res.data.data.pageNo;
      this.tableList.pageSize = res.data.data.pageSize;
    },
    // 表单搜素
    onFormSearch() {
      debounce(
          () => {
            this.$refs['searchFormRef'].validate((valid) => {
              if (valid) {
                this.params.pageNo = 1;
                this.getList();
              } else {
                return false;
              }
            });
          },
          500,
          true
      );
    },
    reset() {
      this.searchForm = {
        searchContent: '',
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getList();
    },
  },
};
</script>

<style>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/components/goodsList.vue